import { WidgetHeader, WidgetTitle, WidgetDetailsLink } from 'pages/HrDashboard/Widgets/widgetParts.styled'
import { BarLabel, BarTrack, BarFill, BarValue } from 'pages/HrDashboard/hrLayout.styled'
import { GlobalViewWidget, GLWidgetRows, WidgetBarContainer } from '../GlobalView.styled'

export interface GLRow {
  key: string | number
  label: string
  value: number
  pct: number
  color: string
  selected?: boolean
  onClick?: () => void
}

export const GLWidget = ({
  title,
  onViewAll,
  rows,
}: {
  title: string
  onViewAll?: () => void
  rows: GLRow[]
}) => (
  <GlobalViewWidget>
    <WidgetHeader>
      <WidgetTitle>{title}</WidgetTitle>
      {onViewAll && <WidgetDetailsLink onClick={onViewAll}>View all ›</WidgetDetailsLink>}
    </WidgetHeader>
    <GLWidgetRows>
      {rows.map((r) => (
        <WidgetBarContainer key={r.key} selected={r.selected} onClick={r.onClick}>
          <BarLabel>{r.label}</BarLabel>
          <BarTrack>
            <BarFill $pct={r.pct} $color={r.color} />
          </BarTrack>
          <BarValue>{r.value}</BarValue>
        </WidgetBarContainer>
      ))}
    </GLWidgetRows>
  </GlobalViewWidget>
)
